/* eslint camelcase: 0 */
import api from '../api';
import { getBackVersion } from '../../config';
import { CRMTaskInput } from '../../models/CRM';
import { CrmTaskStatus } from '../../constants/crm/crmTask';

const getCRMTasks = (): Promise<CRMTaskInput[]> => {
    return api.request<CRMTaskInput[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/ai/tasks`,
    });
};

const patchCRMTaskStatus = (
    taskId: number,
    status: CrmTaskStatus
): Promise<CRMTaskInput> => {
    return api.request<CRMTaskInput>({
        method: 'PATCH',
        url: `${getBackVersion()}/agent/ai/tasks/${taskId}/status`,
        params: { status },
    });
};

export default { getCRMTasks, patchCRMTaskStatus };
